var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.1 49.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.55,49.57c-.98,0-1.86-.59-2.24-1.49-.51-1.23.08-2.65,1.31-3.16,1.81-.75,3.75-1.7,5.93-2.92,1.7-.95,3.92-2.26,6.06-3.91l.14-.11-.17-.05c-.2-.06-.39-.13-.57-.2-2.26-.89-3.94-2.81-4.61-5.28-.75-2.75-.15-5.79,1.54-7.95,1.37-1.75,3.28-2.9,5.37-3.25.43-.07.86-.1,1.29-.1,2,0,3.92.74,5.42,2.08,1.76,1.57,2.73,3.81,2.67,6.14v.25s.16-.18.16-.18c.26-.28.51-.56.75-.86.85-1.07,1.51-2.21,1.97-3.39.47-1.19.7-2.42.7-3.66,0-8.89-12.02-16.68-25.71-16.68S4.84,12.64,4.84,21.52c0,7.46,8.58,14.02,20.39,15.59,1.32.18,2.25,1.4,2.08,2.72-.16,1.2-1.18,2.1-2.38,2.1-.11,0-.22,0-.34-.02C10.34,40.02,0,31.44,0,21.52,0,9.86,13.99,0,30.55,0s30.55,9.86,30.55,21.52c0,1.84-.35,3.66-1.03,5.41-.64,1.64-1.54,3.2-2.69,4.64-2.03,2.56-4.64,4.53-7.53,5.71-.2.08-.41.16-.62.24-.13.13-.21.23-.3.33-3.33,3.82-7.64,6.48-11.01,8.37-2.31,1.29-4.42,2.33-6.44,3.16-.3.12-.61.19-.92.19ZM44.61,25.98c-.17,0-.34.01-.51.04-.88.15-1.74.68-2.35,1.46-.76.97-1.03,2.42-.68,3.7.19.7.64,1.63,1.71,2.04.53.21,1.14.31,1.81.31.53,0,1.1-.06,1.69-.19.98-1.42,1.51-2.8,1.57-4.04.05-.93-.33-1.83-1.05-2.48-.61-.55-1.39-.85-2.19-.85Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalk);
export default __webpack_public_path__ + "static/media/talk.fa94932ad26c8398587c0ba379e350ae.svg";
export { ForwardRef as ReactComponent };